import { COMMIT_RATIO } from '../constants';

interface ISwipeCommitParams {
  offset: number;
  messageElement: HTMLElement;
  commitRatio?: number;
}

/**
 * Завершён ли свайп — пора ли вызывать onSwipe.
 *
 * Свайп считается завершённым, если сдвиг дошёл до порога в долю ширины
 * сообщения — по умолчанию 15% (COMMIT_RATIO); доехать до самого предела
 * необязательно. Доля берётся из RS-настройки chats.replies.swipeConfig
 * (useSwipeConfig).
 */
export const isSwipeCommitted = ({
  offset,
  messageElement,
  commitRatio = COMMIT_RATIO,
}: ISwipeCommitParams): boolean => {
  const { width } = messageElement.getBoundingClientRect();

  return Math.abs(offset) >= width * commitRatio;
};
